import { SettingsDevicesEapSettingsFromContainer } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.container';
import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromADM } from '@root/src/core/contexts/device-types';

export const SettingsDevicesEapSettingsFormScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromADM} source={DEVICE_TYPE_SOURCE.ADM}>
        <SettingsDevicesEapSettingsFromContainer />
    </DeviceTypesProvider>
);

export default SettingsDevicesEapSettingsFormScene;
